<template>
    <div class="body">
        <div class="search-box">
            <div style="margin-right: 20px">
                <span class="title">年级：</span>
                <el-date-picker
                    v-model="year"
                    type="year"
                    placeholder="选择年"
                    format="yyyy"
                    value-format="yyyy"
                    @change="getData"
                    style="width: 240px"
                >
                </el-date-picker>
            </div>
            <div>
                <span class="title">专业名称：</span>
                <el-input
                    class="search-input"
                    v-model="content"
                    placeholder="请输入专业代码或专业名称"
                    clearable
                    @change="getData"
                ></el-input>
            </div>
            <div class='margin-left-30'>
                <el-button class="primary-btn" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="reloadData()">查询</el-button>
            </div>
        </div>
        <div class="container">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" class="handle-del mr10" @click="handleAdd"
                            >添加专业
                        </el-button>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" class="handle-del mr10" @click="importVisible=true">
                            导入教学计划
                        </el-button>
                        <el-button type="primary"
                                   @click="downloadImportTemp"
                        >下载导入模板
                        </el-button>
                        <el-button type="primary"
                                   @click="goToTaskPage"
                        >查看进度
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <!-- 表单 -->
            <div class="table-cls">
                <el-table
                    :data="tableData"
                    border
                    fit
                    class="table"
                    :cell-style="{ color: '#666666' }"
                    @sort-change="changeSort"
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    :header-cell-style="{ background: '#eef1f6', color: '#333333', height: '49px', fontWeight: 500 }"
                >
                    <el-table-column prop="grade" label="年级" align="center" width="120px"> </el-table-column>
                    <el-table-column prop="major_code" label="专业代码" align="center" width="120px"> </el-table-column>
                    <el-table-column prop="academic" label="学制" align="center" width="120px">
                        <template slot-scope="scope">
                            <div>
                                {{ academicsList[scope.row.academic] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="专业名称" align="center" min-width="400px"> </el-table-column>
                    <el-table-column prop="level" label="层次" align="center" width="120px">
                        <template slot-scope="scope">
                            <div>
                                {{ gradation[scope.row.level] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="regis_num" width="100px" label="人数" sortable="custom" align="center"> </el-table-column>
                    <el-table-column prop="org" width="200px" align="center" label="所属院校" v-if="this.org === '1'">
                        <template slot-scope="scope">
                            {{ org_list_hash[scope.row.org] }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="360px" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button class="primary-btn" @click="handleArrang(scope.row)">教学计划</el-button>
                            <el-button class="primary-btn" @click="handleDetails(scope.$index, scope.row)">详细名单</el-button>
                            <el-button class="primary-btn" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)"
                                :disabled="org != scope.row.org"
                                style="margin-left: 16px"
                                >删除</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="10"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 弹出框 -->
        <el-dialog :title="sec_title" :visible.sync="academyValue" width="440px" :before-close="CloseInfo"
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-form :disabled="form.org != this.org" ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="年级：" prop="grade">
                    <div class="year-input">
                        <el-date-picker
                            v-model="form.grade"
                            type="year"
                            placeholder="选择年级"
                            format="yyyy"
                            value-format="yyyy"
                            style="width: 240px"
                        >
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="专业代码：" prop="major_code">
                    <el-input v-model="form.major_code" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="专业名称：" prop="name">
                    <el-input v-model="form.name" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="层次：" prop="level">
                    <el-select style="width: 240px" clearable v-model="form.level" placeholder="层次">
                        <el-option v-for="(item, index) in level" :label="item.label" :value="item.value" :key="index"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学制：" prop="academic">
                    <el-select style="width: 240px" clearable v-model="form.academic" placeholder="学制">
                        <el-option v-for="(item, index) in academicstab" :label="item.label" :value="item.value" :key="index"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="academyValue = false">取 消</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="saveEdit" :disabled="form.org != this.org">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 教学计划 -->
        <div>
            <el-dialog  :close-on-click-modal='false' :close-on-press-escape='false'
                        title="教学计划"
                        :visible.sync="previewVisible"
                        width="1000px"
                        :before-close="closePreviewDialog">
                <el-form ref="form" :model="form" label-width="70px" >
                    <el-form-item class="form-item" label-width="54px" label="年级：" prop="grade" >
                        <el-input class='page-input'  placeholder="请输入年级" v-model="form.grade" disabled style="width: 392px"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item"  label-width="54px" label="专业：" prop="name">
                        <el-input class='page-input' placeholder="请输入专业" v-model="form.name" disabled style="width: 392px"></el-input>
                    </el-form-item>
                    <div style="margin-left: 54px" v-for="(item,index) in previewData">
                        <div class="semester-title">
                            {{majorSemester[1][item.semester]}}
                        </div>
                        <div class="crs-content">
                            <div class="crs-box" v-for="(it,idx) in item.crs_list">
                                <div class="crs-sort-num">
                                    {{it.sort_num}}
                                </div>
                                <div class="crs-name">
                                    <div v-if='it.other_name '>
                                        {{ it.other_name }}
                                    </div>
                                    <div v-else>
                                        {{ crsDataHash[it.crs_id] }}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="previewVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- 导入弹出框 -->
        <el-dialog title='导入教学计划' :visible.sync="importVisible" width="638px"
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-form ref='importFormRef' :rules="rules">
                <el-form-item label='专业：' class='form-item' label-width="100px" prop='major'>
                    <el-select v-model="importForm.major" class='search-input' style='width: 360px'
                               clearable filterable placeholder="请选择">
                        <el-option
                            v-for="item in majorList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-item" label-width="100px" label="教学计划：" prop="excel">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        drag
                        :action=this.FILE_TEMP_URL
                        :file-list="importForm.fileList"
                        :limit=1
                        :before-upload="onBeforeUpload"
                        :on-success="onSuccessUpload"
                        :on-remove="onRemoveUpload"
                        multiple
                    >
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传xlsx文件,且大小不能超过2M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
		        <el-button @click="closeImport">取 消</el-button>
		        <el-button type="primary" @click="saveImport">确 定</el-button>
		    </span>
        </el-dialog>
    </div>
</template>

<script>
import { isBlank, isValidPhone, isNumber, isLeng32 } from '../../utils/util';
import { post } from '../../utils/http';
export default {
    data() {
        return {
            majorList: [],
            importVisible:false,
            previewVisible:false,
            academicstab:[],
            previewData:[],
            majorSemester:[],
            crsDataHash:[],
            crsData:[],
            importForm: {
                name: '',
                phone: null,
                id_card: '',
                gender: '',
                pm_id: '',
                valid_date: '',
                org: '',
                add_user: '',
                add_time: '',
                major: ''
            },
            // 搜索内容
            content: '',
            year: '',
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            //弹出框
            sec_title: '新增',
            //排序
            sort: '',
            // 规则
            rules: {
                name: [
                    { type: 'string', required: true, message: '请正确输入专业名称', trigger: 'blur' },
                    { max: 32, message: '长度不能超过32个字符' }
                ],
                major_code: [
                    { type: 'number', required: true, message: '请正确输入专业代码', trigger: 'blur', transform: (value) => Number(value) }
                ],
                grade: [{ type: 'string', required: true, message: '请正确输入年级', trigger: 'blur' }],
                level: [{ type: 'number', required: true, message: '请正确输入层次', trigger: 'blur' }],
                major: [{required: true, message: '请选择专业', trigger: 'blur' }]
            },
            // 弹出开关
            academyValue: false,
            // 请求数据
            form: {
                id: '',
                major_code: '',
                name: '',
                grade: '',
                level: '',
                academic:''
            },
            // 层次
            level: '',
            gradation: [],
            academicsList:[],
            org_list_hash: [],
            org: -1
        };
    },
    computed:{

    },
    created() {
        this.getData();
        this.getTblInfo();
        this.getTransitionValue();
        this.getCrsData();
        //获取当前账号的所属院校
        this.org = localStorage.getItem('org');
    },
    methods: {
        downloadImportTemp(){
            window.open('https://crjyxspt.zikaoj.com/static/file/temp_file/%E6%95%99%E5%AD%A6%E8%AE%A1%E5%88%92%E6%A8%A1%E6%9D%BF.xlsx')
        },
        goToTaskPage(){
            this.$router.push({ path: '/task' })
        },
        // 保存导入
        saveImport() {
            if (this.importForm.major == null || this.importForm.major == "" ){
                this.$message.error('专业不能为空！');
                return false
            }
            //每次保存前，校验文件是否已经上传
            if (isBlank(this.importForm.fileList)) {
                this.$message.error('请上传导入的试题文件！');
                return false;
            }
            let form = this.importForm;
            let that = this
            const loading = this.$loading({
                lock: true,//lock的修改符--默认是false
                text: '数据导入中,请耐心等待。',//显示在加载图标下方的加载文案
                spinner: 'el-icon-loading',//自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                target: document.querySelector('#table')//loadin覆盖的dom元素节点
            });
            this.$post(
                this.BASEURL + '/arrangement/import/semester/course',
                { 'file_url': form.fileList[0].url, 'file_name': form.fileList[0].name, "majorId": form.major }).then((res) => {
                if (res.code === 200) {
                    this.closeImport();
                    this.$message.success(`导入任务开启成功！请到“查看进度”按钮中查看`);
                } else {
                    this.errorList = res.error_list;
                    this.errorShow = true;
                    this.$message.error(res.error);
                }
                loading.close();
            }).catch(function(e){
                setTimeout(function(){
                    loading.close()
                    that.$message.error("保存失败，请检查您的网络设置。");
                },500)
            });
        },
        closeImport() {
            this.error_show = false;
            this.error_html = '';
            this.importForm.fileList = [];
            this.$refs.upload.clearFiles();
            this.importVisible = false;
            this.importForm = { brand_right: 0 };
        },
        onBeforeUpload(file) {
            let isXlsx = file.name.indexOf('.xlsx') > 0 || file.name.indexOf('.xls') > 0;


            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isXlsx) {
                this.$message.error('上传文件只能是 xlsx 格式');
                return false;
            } else {
                return file;
            }

            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 2MB');
                return false;
            }
        },
        onSuccessUpload(response, file, fileList) {
            this.importForm.fileList = [
                {
                    'url': this.STATIC_URL + response.data.url,
                    'name': response.data.name
                }
            ];
        },
        onRemoveUpload(file, fileList) {
            this.importForm.fileList = [];
        },
        //获取课程列表
        getCrsData() {
            this.$get(this.BASEURL+'/tution/course/GET').then((res)=>{
                if(res.code === 200){
                    this.crsData = res.crsData
                    let hash = []
                    this.crsData.forEach((item,index)=>{
                        hash[item.id] = item.name
                    })
                    this.crsDataHash = hash
                }else{
                    console.log(res.error);
                }
            });
        },
        //获取转换值列表
        getTransitionValue(){
            let data = ['major_semester']
            this.$post(
                this.BASEURL + '/assets/transition/GET', {
                    'key_list': data
                }).then((res) => {
                if (res.code === 200) {
                    this.majorSemester = res.data.major_semester
                } else {
                    console.log(res.error);
                }
            });
        },
        closePreviewDialog(){
            this.previewVisible = false
        },
        getData() {
            this.$get(
                this.BASEURL +
                    '/major/management?page=' +
                    this.pageIndex +
                    '&content=' +
                    this.content +
                    '&grade=' +
                    this.year +
                    '&sort=' +
                    this.sort
            ).then((res) => {
                if (res.code === 200) {
                    console.log('搜索', res);
                    this.tableData = res.data;
                    this.pageTotal = res.total;
                } else {
                    console.log(res.error);
                }
            });
            // 层次数据获取
            this.getTransition();
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            console.log(val); // column: {…} order: "ascending" prop: "date"
            this.sort = val.order;
            console.log(this.sort); // column: {…} order: "ascending" prop: "date"
            this.getData();
        },
        getTblInfo() {
            let data = this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [['org', 'org_name', 'academy_base_t'],['id', 'grade,level,name,academic', 'major_base_t']],
                state: 0
            }).then((res) => {
                if (res.code === 200) {
                    this.org_list_hash = res.data[0][1];
                    this.majorList = res.data[1][0];
                } else {
                    console.log(res.error);
                }
            });
        },
        // 转换值层次
        getTransition() {
            let data = ['study_levels','academics',];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then((res) => {
                if (res.code === 200) {
                    this.gradation = res.data.study_levels[1];
                    this.level = res.data.study_levels[0];
                    this.academicsList = res.data.academics[1]; //学制
                    this.academicstab = res.data.academics[0]; //学制
                } else {
                    console.log(res.error);
                }
            });
        },
        reset() {
            this.content = '';
            this.year = '';
            this.reloadData();
        },
        // 刷新功能
        reloadData() {
            this.pageIndex = 1;
            this.getData();
        },
        // 分页导航
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        // 触发搜索按钮
        // handleSearch() {
        //     this.pageIndex = 1
        //     this.getData();
        // },
        //弹出框开关
        CloseInfo() {
            this.academyValue = false;
        },
        // 添加按钮
        handleAdd() {
            this.academyValue = true;
            this.form = {
                id: '',
                major_code: '',
                name: '',
                grade: '',
                level: '',
                org: this.org,
                academic:0
            };
        },
        handleArrang(row){
            console.log(row.id)
            this.getPreviewData(row.id)
            this.form.grade = row.grade
            this.form.name = row.name
        },
        getPreviewData(id){
            this.$get(this.BASEURL + `/arrangement/management?major_id=${id}&option=2`).then((res) => {
                if (res.code === 200) {
                    this.previewData = res.data
                    let arr = []
                    this.previewData.forEach((item,index)=>{
                        if(item.crs_list.length !== 0){
                            arr.push(item)
                        }
                    })
                    this.previewData = arr

                    if(this.previewData.length === 0){
                        this.$message.error('暂无排课信息！')
                    }else{
                        this.previewVisible = true
                    }

                    console.log('this.previewData', this.previewData);
                } else {
                    console.log(res.error);
                }
            });
        },
        handleDetails(index, row) {
            let data = {
                grade: row.grade,
                major: row.id,
                level: row.level
            };

            data = JSON.stringify(data);

            this.$router.push({
                path: '/student',
                query: {
                    majorPageData: data
                }
            });
        },
        // 编辑按钮
        handleEdit(index, row) {
            this.idx = index;
            if (!isBlank(row.id)) {
                this.form = row;
                this.form.grade = row.grade.toString();
            }
            console.log(this.form)
            this.sec_title = '编辑';
            this.academyValue = true;
        },
        // 确认按钮
        saveEdit() {
            //每次保存前，都需要校验
            if (isBlank(this.form.name)) {
                this.$message.error('专业名称不能为空！');
                return;
            }
            if (isBlank(this.form.major_code)) {
                this.$message.error('专业代码不能为空！');
                return;
            }
            if (isBlank(this.form.grade)) {
                this.$message.error('年级不能为空！');
                return;
            }
            if (isBlank(this.form.level)) {
                this.$message.error('层次不能为空！');
                return;
            }
            if (!isNumber(this.form.major_code)) {
                this.$message.error('专业代码请填写数字！');
                return;
            }

            if (this.form.name.trim().length >= 32) {
                this.$message.error('专业名称太长,请重新输入！');
                return;
            }
            console.log(this.form)
            if (isBlank(this.form.id)) {
                // 增加
                this.addAcademy();
            } else {
                // 修改
                this.alterAcademy();
            }
        },
        // 添加请求
        addAcademy() {
            console.log(this.form);
            this.$post(this.BASEURL + '/major/management', {
                major_code: this.form.major_code,
                name: this.form.name,
                grade: this.form.grade,
                level: this.form.level,
                academic: this.form.academic

            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(`添加成功！`);
                    this.CloseInfo();
                    this.reloadData();
                } else {
                    this.$message.error(res.error);
                    console.log(res.error);
                    console.log(res);
                }
            });
        },
        //修改请求
        alterAcademy() {
            this.form.year = Number(this.form.year);
            this.$put(this.BASEURL + '/major/management', {
                id: this.form.id,
                major_code: this.form.major_code,
                name: this.form.name,
                grade: this.form.grade,
                level: this.form.level,
                academic: this.form.academic
            }).then((res) => {
                if (res.code === 200) {
                    this.CloseInfo();
                    this.reloadData();
                    this.$message.success(`编辑成功！`);
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 删除按钮
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // 删除请求
                    this.deleteAcademy(row.id);
                })
                .catch(() => {});
        },
        // 删除请求
        deleteAcademy(id) {
            this.$del(this.BASEURL + '/major/management?id=' + id).then((res) => {
                if (res.code === 200) {
                    this.$message.success('删除成功！');
                    this.reloadData();
                } else {
                    this.$message.error(res.error);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}
.grid-content{
    display: flex;
    flex-shrink: 0;
}
.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    .search-input {
        width: 240px;
    }
    .title {
        font-size: $title-size;
        line-height: 15px;
        color: #343434;
    }
}
.primary-btn {
    border-color: #409eff;
    color: #409eff;
}
.year-input {
    width: 200px;
    display: inline-block;
    margin-right: 20px;
    /* 100 120 */
}

.handle-input {
    width: 300px;
    display: inline-block;
}

/* 表单 */
.table-cls {
    text-align: center;
    margin-top: 28px;
    width: 100%;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.input-search {
    text-align: right;
}
.semester-title{
    margin-top: 10px;
    width:78px;
    height:32px;
    background-color:#EAF2FF;
    border-radius:3px 22px 24px 3px;
    color: #3377FF;

    font-size:12px;
    font-weight:500;
    line-height:32px;
    text-align: center;
}
.crs-content{
    display: flex;
    flex-wrap: wrap;
    .crs-box{
        width: 412px;
        margin-top: 10px;
        margin-bottom: 10px;
        display: flex;
        color: #666666;
        line-height:32px;
        .crs-sort-num{
            text-align: center;
            width: 56px;
            border: 1px solid #CBCBCB;
            border-right: none;
            border-radius: 5px 0 0 5px;
        }
        .crs-name{
            border-radius: 0 5px 5px 0;

            text-align: center;
            margin-right: 20px;
            width: 100%;
            border: 1px solid #CBCBCB;

        }
    }
}
</style>
